<template>
	<rmp-text type="title-small" :color="colors.shades.black" class="mb-4">
		<slot></slot>
	</rmp-text>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";

const { colors } = useColors();
</script>
